import { render, staticRenderFns } from "./SalesPropertyTax.vue?vue&type=template&id=1612f08d"
import script from "./SalesPropertyTax.vue?vue&type=script&lang=js"
export * from "./SalesPropertyTax.vue?vue&type=script&lang=js"
import style0 from "./SalesPropertyTax.vue?vue&type=style&index=0&id=1612f08d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports